<template>
  <div class="app-container">
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">添加</el-button>
        <el-button class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
        <el-button class="action-item" icon="el-icon-setting" type="success" @click="Presetsdialog = true">预设自定义字段</el-button>
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <!-- <el-table-column type="selection"></el-table-column> -->
      <el-table-column type="selection"></el-table-column>
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
      <!-- <el-table-column align="center" prop="field" label="字段名"></el-table-column> -->
      <el-table-column align="center" prop="name" label="字段中文名"></el-table-column>
      <el-table-column align="center" prop="form_text" label="表单类型"></el-table-column>
      <el-table-column align="center" prop="listorder" label="排序" sortable></el-table-column>
      <el-table-column align="center" prop="status" label="是否必填">
        <template slot-scope="{row}">
          <el-tag v-if="row.require == 0" type="success">否</el-tag>
          <el-tag v-else type="danger">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="create_time" width="180" label="添加时间" sortable></el-table-column>
      <el-table-column align="center" prop="" label="操作" width="200" class-name="action">
        <template slot-scope="scopes">
          <el-button type="text" plain icon="el-icon-edit" size="mini" @click="HandleUpdate(scopes.row)">
            编辑
          </el-button>
          <el-button type="text" plain icon="el-icon-delete" size="mini" @click="RowDelete(scopes.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />

    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus == 'create' ? '新增' : '编辑'" :visible.sync="dialogFormVisible">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="150px" style="width: 600px; margin-right:50px;">
        <el-alert title="提示" type="error" style="margin-bottom: 10px">
          姓名,性别,邮箱,户籍地,年龄,手机号码,民族,身份证,身份证照片已默认设置，无需设置
        </el-alert>
        <el-form-item label="表单类型" prop="formtype">
          <el-select v-model="temp.formtype" placeholder="请选择表单类型" :disabled="dialogStatus !== 'create'">
            <el-option v-for="item in formTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="排序（从小到大）">
          <el-input-number v-model="temp.listorder" :min="1"></el-input-number>
        </el-form-item>
        <!-- <el-form-item label="字段名" prop="field">
          <el-input v-model="temp.field" placeholder="只能由英文字母组成" :readonly="dialogStatus=='update'"></el-input>
        </el-form-item> -->

        <el-form-item label="字段中文名" prop="name">
          <el-input v-model="temp.name" placeholder="例如：文章标题"></el-input>
        </el-form-item>

        <el-form-item label="字段提示">
          <el-input v-model="temp.tips" autosize placeholder="显示在字段别名下方作为表单输入提示" type="textarea"></el-input>
        </el-form-item>

        <el-form-item v-if="temp.formtype != 'date' && temp.formtype != 'datetime'" label="相关参数">
          <el-form-item v-if="temp.formtype == 'text'" label="文本框长度">
            <el-input-number v-model="temp.setting.size" :min="1"></el-input-number>
          </el-form-item>
          <el-form-item v-if="temp.formtype == 'textarea' || temp.formtype == 'json'" label="文本域宽度">
            <el-input-number v-model="temp.setting.width" :min="1"></el-input-number> %
          </el-form-item>
          <el-form-item v-if="temp.formtype == 'textarea' || temp.formtype == 'json'" label="文本域高度">
            <el-input-number v-model="temp.setting.height" :min="1"></el-input-number> PX
          </el-form-item>

          <el-form-item v-if="temp.formtype == 'box'" label="选项列表">
            <el-alert title="多个选项用回车符隔开" type="error" style="margin-bottom: 10px"></el-alert>
            <el-input v-model="temp.setting.options" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="多个选项用回车符隔开" type="textarea"></el-input>
          </el-form-item>
          <el-form-item v-if="temp.formtype == 'box'" label="选项类型">
            <el-radio-group v-model="temp.setting.boxtype">
              <el-radio-button label="radio">单选</el-radio-button>
              <el-radio-button label="select">下拉框</el-radio-button>
              <el-radio-button label="checkbox">复选框</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="temp.formtype == 'image' || temp.formtype == 'images'" label="图像大小">
            <el-form-item>
              <el-input-number v-model="temp.setting.images_width" :min="1"></el-input-number> 宽（px）
            </el-form-item>
            <el-form-item>
              <el-input-number v-model="temp.setting.images_height" :min="1"></el-input-number> 高（px）
            </el-form-item>
          </el-form-item>

          <el-form-item v-if="temp.formtype == 'images' || temp.formtype == 'files'" label="允许同时上传的个数">
            <el-input-number v-model="temp.setting.upload_number" :min="1"></el-input-number>
          </el-form-item>

          <el-form-item v-if="temp.formtype == 'decimal' || temp.formtype == 'number'" label="取值范围">
            <el-form-item>
              <el-input-number v-model="temp.setting.min" :min="1"></el-input-number> 最小值
            </el-form-item>
            <el-form-item>
              <el-input-number v-model="temp.setting.max" :min="1"></el-input-number> 最大值
            </el-form-item>
          </el-form-item>

          <el-form-item v-if="temp.formtype == 'decimal'" label="小数位数">
            <el-input-number v-model="temp.setting.decimaldigits" :min="0" :max="2"></el-input-number>
          </el-form-item>

          <el-form-item v-if="temp.formtype != 'images' && temp.formtype != 'files' && temp.formtype != 'date' && temp.formtype != 'datetime'" label="默认值">
            <el-input v-model="temp.setting.defaultvalue" placeholder="默认值"></el-input>
          </el-form-item>
        </el-form-item>

        <el-form-item label="是否必填" prop="require">
          <el-radio-group v-model="temp.require">
            <el-radio-button label="0">否</el-radio-button>
            <el-radio-button label="1">是</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-row>
          <el-col :span="19">
            <el-form-item label="数据校验正则">
              <el-input v-model="temp.pattern" clearable placeholder="系统将通过此正则校验表单提交的数据合法性，如果不想校验数据请留空"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-select v-model="temp.pattern" placeholder="常用正则" @change="selectRegEx($event)">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>

        <el-form-item label="校验未通过提示信息">
          <el-input v-model="temp.errortips" placeholder="正则数据校验未通过的提示信息"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="'选择预设字段'" :visible.sync="Presetsdialog">
      <template>
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <!-- <el-table-column label="日期" width="120">
            <template slot-scope="scope">{{ scope.row.date }}</template>
          </el-table-column> -->
          <el-table-column prop="name" label="字段名称" width="120">
          </el-table-column>
          <el-table-column prop="tips" label="字段提示" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="errortips" label="数据校验提示" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="Presetsdialog = false">取消</el-button>
        <el-button type="primary" @click="ConfirmPresetsData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/examination/field' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'

export default {
  name: 'Field',
  components: { Pagination },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {
        formtype: [
          {
            required: true,
            message: '请选择字段类型',
            trigger: ['blur', 'change']
          }
        ],
        // 'field': [
        //   { required: true, message: '请输入字段名', trigger: ['blur', 'change'] },
        //   { pattern: /^[a-z]+$/i, message: '只能由英文字母组成', trigger: ['blur', 'change'] }
        // ],
        name: [
          {
            required: true,
            message: '请输入字段中文名',
            trigger: ['blur', 'change']
          }
        ],
        require: [
          {
            required: true,
            message: '请选择是否必填',
            trigger: ['blur', 'change']
          }
        ]
      },
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'order', // 默认排序方式,
        sort: 'id',
        form_id: 0
      },
      Presetsdialog: false,
      temp: {
        require: 0,
        setting: {
          size: 200,
          width: 100,
          height: 200,
          options: '',
          boxtype: 'radio',
          images_width: 100,
          images_height: 100,
          upload_number: 10,
          min: 1,
          max: 9999,
          decimaldigits: 0,
          defaultvalue: ''
        }
      },
      subData: {},
      formTypeOptions: [
        {
          value: 'text',
          label: '单行文本'
        },
        {
          value: 'textarea',
          label: '多行文本'
        },
        // {
        //   value: 'editor',
        //   label: '编辑器'
        // },
        {
          value: 'box',
          label: '选项'
        },
        {
          value: 'image',
          label: '单图'
        },
        {
          value: 'images',
          label: '多图'
        },
        {
          value: 'file',
          label: '单文件'
        },
        {
          value: 'files',
          label: '多文件'
        },
        {
          value: 'number',
          label: '数字'
        },
        {
          value: 'decimal',
          label: '小数'
        },
        {
          value: 'date',
          label: '日期（2023-04-13）'
        },
        {
          value: 'datetime',
          label: '日期（2023-04-13 12:01:01）'
        },
        {
          value: 'json',
          label: 'JSON(工作经历等)'
        }
      ],
      selectRegExV: '',
      options: [
        {
          value: '^[\\u4e00-\\u9fa5]{0,}$',
          label: '中文'
        },
        {
          value: '^[0-9.-]+$',
          label: '数字'
        },
        {
          value: '^[0-9-]+$',
          label: '整数'
        },
        {
          value: '^[A-Za-z]+$',
          label: '字母'
        },
        {
          value: '^[A-Za-z0-9]+$',
          label: '数字+字母'
        },
        {
          value: '^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$',
          label: 'E-mail'
        },
        {
          value: '^[0-9]{5,20}$',
          label: 'QQ'
        },
        {
          value: '^[0-9]{6}$',
          label: '邮政编码'
        },
        {
          value: '^1[3|4|5|6|7|8|9][0-9]\\d{8}$',
          label: '手机号码'
        },
        {
          value: '^[0-9-]{6,13}$',
          label: '电话号码'
        },
        {
          value: '^(?=.*d)(?=.*[a-z])(?=.*[A-Z]).{8,10}$',
          label: '密码(大小写字母+数字,8-10位)'
        },
        {
          value: '^\\d{8,18}|[0-9x]{8,18}|[0-9X]{8,18}?$',
          label: '身份证号码'
        }
      ],
      tableData: [{
        name: '政治面貌',
        tips: '请输入政治面貌',
        errortips: '输入的政治面貌不符合',
        formtype: 'text',
        listorder: 1,
        require: 1,
        pattern: '^[\\u4e00-\\u9fa5]{0,}$'
      }, {
        name: '学历',
        tips: '请输入学历',
        errortips: '输入的学历不符合',
        formtype: 'text',
        listorder: 1,
        require: 1,
        pattern: '^[\\u4e00-\\u9fa5]{0,}$'
      }, {
        name: '所学专业',
        tips: '请输入所学专业',
        errortips: '输入的所学专业不符合',
        formtype: 'text',
        listorder: 1,
        require: 1,
        pattern: '^[\\u4e00-\\u9fa5]{0,}$'
      }, {
        name: '毕业时间',
        tips: '请输入毕业时间',
        errortips: '输入的毕业时间不符合',
        formtype: 'text',
        listorder: 1,
        require: 1,
        pattern: '^[\\u4e00-\\u9fa5]{0,}$'
      }, {
        name: '毕业院校',
        tips: '请输入毕业院校',
        errortips: '输入的毕业院校不符合',
        formtype: 'text',
        listorder: 1,
        require: 1,
        pattern: '^[\\u4e00-\\u9fa5]{0,}$'
      }, {
        name: '学习经历',
        tips: '请输入学习经历',
        errortips: '输入的学习经历不符合',
        formtype: 'json',
        listorder: 1,
        require: 1
      }, {
        name: '工作经历',
        tips: '请输入工作经历',
        errortips: '输入的工作经历不符合',
        formtype: 'json',
        listorder: 1,
        require: 1
      }, {
        name: '出生日期',
        tips: '请输入出生日期',
        errortips: '输入的出生日期不符合',
        formtype: 'date',
        listorder: 1,
        require: 1
      }, {
        name: '户籍所在地',
        tips: '请输入户籍所在地',
        errortips: '输入的户籍所在地不符合',
        formtype: 'text',
        listorder: 1,
        require: 1,
        pattern: '^[\\u4e00-\\u9fa5]{0,}$'
      }, {
        name: '健康状况',
        tips: '请输入健康状况',
        errortips: '输入的健康状况不符合',
        formtype: 'text',
        listorder: 1,
        require: 1,
        pattern: '^[\\u4e00-\\u9fa5]{0,}$'
      }
      ],
      multipleSelection: []
    }
  },
  created() {
    this.listQuery.form_id = this.$route.query.form_id
    this.loadData() // 页面加载创建时加载数据
  },
  mounted: function() {},
  methods: {
    selectRegEx(value) {
      console.log(value)
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        require: 0,
        listorder: 1,
        setting: {
          size: 200,
          width: 100,
          height: 200,
          options: '选项名称A',
          boxtype: 'radio',
          images_width: 100,
          images_height: 100,
          upload_number: 10,
          min: 1,
          max: 9999,
          decimaldigits: 0,
          defaultvalue: ''
        }
      }
    },
    packageData() {
      this.temp.form_id = this.$route.query.form_id
      this.subData = this.temp
      switch (this.temp.formtype) {
        case 'text':
          this.subData.setting = {
            size: this.temp.setting.size,
            defaultvalue: this.temp.setting.defaultvalue
          }
          break
        case 'textarea':
          this.subData.setting = {
            width: this.temp.setting.width,
            height: this.temp.setting.height,
            defaultvalue: this.temp.setting.defaultvalue
          }
          break
        case 'box':
          this.subData.setting = {
            options: this.temp.setting.options,
            boxtype: this.temp.setting.boxtype,
            defaultvalue: this.temp.setting.defaultvalue
          }
          break
        case 'image':
          this.subData.setting = {
            size: this.temp.setting.size,
            images_width: this.temp.setting.images_width,
            images_height: this.temp.setting.images_height,
            defaultvalue: this.temp.setting.defaultvalue
          }
          break
        case 'images':
        case 'files':
          this.subData.setting = {
            upload_number: this.temp.setting.upload_number
          }
          break
        case 'content':
        case 'file':
          this.subData.setting = {
            defaultvalue: this.temp.setting.defaultvalue
          }
          break
        case 'number':
          this.subData.setting = {
            min: this.temp.setting.min,
            max: this.temp.setting.max,
            defaultvalue: this.temp.setting.defaultvalue
          }
          break
        case 'decimal':
          this.subData.setting = {
            min: this.temp.setting.min,
            max: this.temp.setting.max,
            decimaldigits: this.temp.setting.decimaldigits,
            defaultvalue: this.temp.setting.defaultvalue
          }
          break
        case 'json':
          this.subData.setting = {
            width: this.temp.setting.width,
            height: this.temp.setting.height,
            defaultvalue: this.temp.setting.defaultvalue
          }
          break
        default:
          this.subData.setting = {}
          break
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 获取多选的数据
    handleSelectionChange(val) {
      this.multipleSelection = val// 存储选中的数据
      this.multipleSelection.forEach((item, index) => {
        switch (item.formtype) {
          case 'text':
            item.setting = {
              size: this.temp.setting.size,
              defaultvalue: this.temp.setting.defaultvalue
            }
            break
          case 'json':
            item.setting = {
              width: this.temp.setting.width,
              height: this.temp.setting.height,
              defaultvalue: this.temp.setting.defaultvalue
            }
            break
          default:
            this.subData.setting = {}
            break
        }
      })
    },
    // 多选框选中
    ConfirmPresetsData() {
      if (this.multipleSelection.length === 0) {
        this.$message({ message: '请选择数据', type: 'error' })
        return false
      }
      const form_id = this.$route.query.form_id
      this.api.AllCreate({ form_id: form_id, list: this.multipleSelection }).then((response) => {
        this.Presetsdialog = false
        this.toggleSelection()
        this.loadData()
        this.$notify({
          title: '成功',
          message: '创建成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    // 提交添加
    CreateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.packageData()
          this.api.Create(this.subData).then((response) => {
            this.dialogFormVisible = false
            this.SearchData()
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    // 提交修改
    UpdateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          this.api.Update(tempData).then((response) => {
            for (const v of this.list) {
              if (v.id === this.temp.id) {
                const index = this.list.indexOf(v)
                this.list.splice(index, 1, this.temp)
                break
              }
            }
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    }
  }
}
</script>
